// One sidebar route; the content types and a single item are children so they share its meta.
const TYPE = ':type(custom_sets|grenade_groups|strategies|vpl)';

export default {
  path: '/v5/community_hub',
  children: [
    { path: '', name: 'V5_community_hub', component: () => import('./CommunityHubPage.vue') },
    { path: TYPE, name: 'V5_community_hub_type', component: () => import('./CommunityHubPage.vue') },
    { path: `${TYPE}/:id`, name: 'V5_community_hub_item', component: () => import('./HubContentPage.vue') },
  ],
};
